var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0004 0.500366L7.00039 3.99939L12.0004 7.49939V5.00095C15.8662 5.00116 19 8.13509 19 12.001C19 13.9337 18.2167 15.6835 16.9502 16.9502L18.3644 18.3644C19.9928 16.7358 21 14.486 21 12.001C21 7.03052 16.9708 3.00116 12.0004 3.00095V0.500366ZM12.0004 23.5004L17.0004 20.0004L12.0004 16.5004V19.001C12.0003 19.001 12.0001 19.001 12 19.001C8.13401 19.001 5 15.8669 5 12.001C5 10.0677 5.7837 8.31751 7.05074 7.05072L5.63653 5.6365C4.00756 7.26522 3 9.51542 3 12.001C3 16.9715 7.02944 21.001 12 21.001C12.0001 21.001 12.0003 21.001 12.0004 21.001V23.5004Z",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.ba02a3e78728faf61a700d572719c5e9.svg";
export { ForwardRef as ReactComponent };